// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1HaWd","col":"CardReaderDesc_col__3fUp7","label":"CardReaderDesc_label__HOTSk"};